import './featured-card.scss';
import { 
  appendText,
  getText, 
  sanitizeString 
} from '../../../assets/js/text-renderer';

const getFeatureElement = (data) => `
<article class="feature-card">
  <div class="large-icon">
    <img src="${data.icon}" loading="lazy"/>
  </div>
  <div id="${data.id}" class="secondary">
    ${ data.title ? `<h5>${data.title}</h5>` : ''}
    ${ data.content ? `<p>${data.content}</p>` : ''}
  </div>
  ${ data.link ? `
    <a 
      class="text-button animated" 
      href="${data.link}"
    >
      <span id="learn-more-btn"></span>
    </a>  
  ` : ``}
</article>
`

/**
 * Custom Featured Card Web Component
 * 
 * This component renders a featured card.
 * 
 * Attributes:
 * - card-id: Sets the id of the featured card.
 * - content: Sets the content of the featured card.
 * - icon: Sets the icon of the featured card.
 * - link: Sets the link of the featured card.
 * - title: Sets the title of the featured card.
 * 
 * Example:
 * <custom-featured-card>
 * </custom-featured-card>
 */
class FeatureCard extends HTMLElement {
  connectedCallback() {
    if (
      DEVELOPMENT || (
      window['__PRERENDER_INJECTED'] && 
      window['__PRERENDER_INJECTED'].render_text)
    ) {
      this.render();
      this.loadText();
    }
  }

  render() {
    const featureData = this.getFeatureData();
    this.innerHTML = getFeatureElement(featureData);
  }

  getFeatureData() {
    return {
      id: sanitizeString(this.getAttribute('card-id')),
      title: sanitizeString(this.getAttribute('title')),
      content: sanitizeString(this.getAttribute('content')),
      icon: sanitizeString(this.getAttribute('icon')),
      link: sanitizeString(this.getAttribute('link')),
    };
  };

  loadText() {
    const learnMoreBtn = this.querySelector('#learn-more-btn');
    if(!learnMoreBtn) return;

    getText('shared/keywords')
      .then(data => {
        const content = data.stories[0].content;
        appendText(content.saber_mas, 'learn-more-btn', this);
      })
      .catch(() => {
        appendText('Learn more', 'learn-more-btn', this);
      })
    }
}

customElements.define('custom-feature-card', FeatureCard);